import React from "react";
import { ApolloError } from "@apollo/client";
import { successToast, errorToast } from "Modules/DPToast";
import pretty from "Shared/pretty";
import { ApprovalAction } from "Shared/types/ApprovalActions";
import { useEmployeeProfileQuery } from "Hooks/useEmployeeProfileQueryContext";
import { ApprovalActionsCell } from "Components/Shared/ApprovalActionsCell/ApprovalActionsCell";
import { useUpdateDisbursement } from "./useUpdateDisbursement";

export interface DisbursementActionsProps {
  disbursementId: string;
  totalAmountCents: number;
  onAlreadyReviewed: () => void;
}

const DisbursementActions = ({
  disbursementId,
  totalAmountCents,
  onAlreadyReviewed,
}: DisbursementActionsProps) => {
  const { userDetails } = useEmployeeProfileQuery();
  const { firstName, lastName } = userDetails!.employee;
  const { updateDisbursement } = useUpdateDisbursement();

  const onConfirmAction = async (action: ApprovalAction) => {
    try {
      const response = await updateDisbursement(
        action === ApprovalAction.approve,
        disbursementId
      );

      if (response?.data?.updateDisbursement.message) {
        successToast(response.data.updateDisbursement.message, false);
      }
    } catch (err) {
      if (
        err.networkError &&
        err.networkError.result.length &&
        err.networkError.response.status === 422
      ) {
        errorToast("The disbursement is already approved or rejected.");
        onAlreadyReviewed();
      } else {
        throw new ApolloError(err);
      }
    }
  };

  const getModalText = (action: ApprovalAction) => {
    return action === ApprovalAction.approve
      ? `Click "Approve Payment" to confirm the payment of
        ${pretty.dollar(totalAmountCents)} to
        ${pretty.fullName(firstName!, lastName!)}`
      : "Click \"Reject Payment\" to confirm you are rejecting this payment";
  };

  const getButtonText = (action: ApprovalAction) => {
    return `${action.toLowerCase()} payment`;
  };

  return (
    <ApprovalActionsCell
      actions={[ApprovalAction.approve, ApprovalAction.reject]}
      getModalText={getModalText}
      getButtonText={getButtonText}
      onConfirmAction={onConfirmAction}
    />
  );
};

export default DisbursementActions;
